import React from 'react';
import { Link } from 'react-router-dom';

const MainCircleBorderCard = ({ circleBorderCards, cardId }) => {

  const circleBorderCard = {
    fontSize: '20px',
    width: '310px',
    height: '310px',
    borderRadius: '310px',
    border: '1px solid #FFF',
    margin: '12px',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'end',
    alignItems: 'center',
    textDecorationLine: 'none',
    // transition: 'background-color 0.5s ease',
  };
  
  return (
    <Link className='text-line-none' to={circleBorderCards.url}>
      <div style={circleBorderCard} className={circleBorderCards.wrapClass} id={cardId}>
        <div className={circleBorderCards.imgClass}>
          <img src={circleBorderCards.imgPath} alt={circleBorderCards.alt} />
        </div>
        <div className={circleBorderCards.contentClass}>{circleBorderCards.content}</div> 
      </div>
    </Link>
  );
}

export default MainCircleBorderCard;
